import { z } from "zod";
import type { CategoryPlugin } from "../plugin";

const schema = z.object({
  volume_ml: z.number().positive().optional(),
  base: z.enum(["Oil","Alcohol"]).optional(),
  ball_material: z.enum(["Steel","Glass","Ceramic"]).optional(),
});

export const plugin: CategoryPlugin<z.infer<typeof schema>> = {
  metadata: {
    id: "roll-on-perfumes", slug: "roll-on", name: "Roll-On",
    tagline: "Roller-ball concentrates", status: "launched",
  },
  attributeSchema: schema,
  search: { columns: ["name","family","notes"], attributes: [] },
  facets: [
    { key: "family", label: "Family", type: "enum", source: "column",
      options: ["Floral","Oriental","Woody","Amber","Chypre"] },
    { key: "base", label: "Base", type: "enum", source: "attribute",
      options: ["Oil","Alcohol"] },
    { key: "volume_ml", label: "Volume (ml)", type: "range", source: "attribute",
      min: 5, max: 30, step: 1, unit: "ml" },
    { key: "price", label: "Price (₹)", type: "range", source: "column",
      min: 15, max: 120, step: 5, unit: "₹" },
  ],
  pdpPanels: [
    { key: "product", label: "Product details", attributes: ["volume_ml","base","ball_material"] },
  ],
  seo: {
    titleTemplate: "{name} · CB16 Roll-On",
    descriptionTemplate: "{name} — concentrated roll-on fragrance.",
    routePrefix: "roll-on-perfumes",
  },
  adminForm: [
    { key: "volume_ml", label: "Volume (ml)", kind: "number" },
    { key: "base", label: "Base", kind: "select", options: ["Oil","Alcohol"] },
    { key: "ball_material", label: "Roller material", kind: "select", options: ["Steel","Glass","Ceramic"] },
  ],
};
